const state = {
    selectedClient: null, //stores the selected client(used in form modal)
    clientShow: false, //show=true | edit=false
    formClient: null,
    showClientModal: false,//controls if the form modal is displayed or not
    showClientReceipt: false,
    showClientInvoiceModal: false,
};

const getters = {
    getSelectedClient(state, getters){
        if(!state.selectedClient){
            state.selectedClient = getters.getNewClient;
        }
        return state.selectedClient;
    },
    getFormClient(state, getters){
        if(!state.formClient){
            state.formClient = getters.getEmptyFormCLient;
        }
        return state.formClient;
    },
    getClientShow(state){
        return state.clientShow;
    },
    getShowClientModal(state){
        return state.showClientModal;
    },

    getNewClient(){
        return {
            id: '',
            name: '',
            document_type_id : '',
            companies_id: '',
            nif: '',
            types_company_type_id: '',
            agreed_discount: '',
            countries_id: '',
            cities_id: '',
            address: '',
            postal_code: '',
            active_state: '',
            website: '',
            category: '',
            subcategory: '',
            exempted: '',
            exempted_reason: '',
            contacts_json: [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}],
            description: '',
            created_at: '',
        };
    },

    getEmptyFormCLient(){
        return {
            id: '',
            name: '',
            document_type_id : '',
            nif: '',
            types_company_type_id: '',
            agreed_discount: '',
            countries_id: '',
            cities_id: '',
            address: '',
            postal_code: '',
            active_state: '',
            website: '',
            category: '',
            subcategory: '',
            exempted: '',
            exempted_reason: '',
            companies_id: '',
            description: '',
            contacts_json: [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}],
        }
    },
    
    getShowClientInvoiceModal(state){
        return state.showClientInvoiceModal;
    },
};

const mutations = {
    setSelectedClient(state, payload){ //this also works for new article
        state.selectedClient = payload;
    },
    setFormClient(state, payload){ //this also works for new article
        state.formCient = payload;
    },
    setPreparedFormClient(state, payload){
        if(!payload) return;
        let array = [];
        if(payload.contacts_json){
            array = payload.contacts_json instanceof Array ? array = payload.contacts_json : JSON.parse(payload.contacts_json)
        }

        state.formClient = {
            id: payload ? payload.id : '',
            name: payload ? payload.name : '',
            document_type_id : payload ? payload.document_type_id : '',
            nif: payload ? payload.nif : '',
            types_company_type_id: payload ? payload.types_company_type_id : '',
            agreed_discount: payload ? payload.agreed_discount : '',
            countries_id: payload ? payload.countries_id : '',
            cities_id: payload ? payload.cities_id : '',
            address: payload ? payload.address : 0,
            postal_code: payload ? payload.postal_code : '',
            active_state: payload ? payload.active_state : '',
            website: payload ? payload.website : '',
            companies_id: payload ? payload.companies_id : '',
            category: payload ? payload.category_id : '',
            subcategory: payload ? payload.subcategory_id : '',
            exempted: payload ? payload.exempted : '',
            exempted_reason: payload ? payload.exempted_reason : '',
            description: payload ? payload.description : '',
            contacts_json: payload ? Array.from(array) : [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}],
        };
    },
    setClientShow(state, payload){ //this also works for new article
        state.clientShow = payload;
    },
    setShowClientModal(state, payload){
        state.showClientModal = payload;
    },
    setShowClientInvoiceModal(state, payload){
        state.showClientInvoiceModal = payload;
    },
};

const actions = {
    setSelectedClient( {commit}, payload){
        commit('setSelectedClient', payload);
        commit('setPreparedFormClient', payload);
    },
    setClientShow({commit}, payload){
        commit('setClientShow', payload);
    },
    setShowClientModal({commit}, payload){
        commit('setShowClientModal', payload);
    },
    setShowClientInvoiceModal({commit}, payload){
        commit('setShowClientInvoiceModal', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};

